export default "__VITE_ASSET__D1CESN8P__"